import React from 'react';
import Modal from 'react-bootstrap/Modal';

const ConfirmCryptoVariableSave = (props) => {
  const { isOpen, data, setConfirmSaveData, onSubmit } = props;

  const onClickConfirmVariable = () => {
    onSubmit(data);
  };

  const onCloseModal = () => {
    setConfirmSaveData(false);
  };

  return (
    <>
      <Modal show={isOpen} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar criação</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-variavel-crypto-body">
          <p>
            Ao criar uma variável criptografada, não será possível reverter para
            outro tipo. <br />
            Os valores capturados até o presente momento, serão perdidos. <br />{' '}
            <br />
            Deseja continuar com está ação?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onCloseModal}
          >
            não
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            onClick={onClickConfirmVariable}
          >
            sim
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmCryptoVariableSave;
